module.exports = __webpack_public_path__ + "static/media/Graph_Features_new.f9853638.svg";